module.exports = __webpack_public_path__ + "img/quicktips29.daaa1498.svg";